// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import React, { ReactElement, ReactNode } from 'react';

import './Layout.scss';

interface LayoutProps {
    children: ReactNode;
    header?: ReactNode;
    footer: ReactNode;
    className?: string;
}

export const Layout = ({ children, className, header, footer }: LayoutProps): ReactElement => {
    return (
        <div className={classList('th-form__layout', { 'has-header': !!header })}>
            {header && <div className="th-form__layout__header">{header}</div>}
            <div className={classList('th-form__layout__content', className)}>{children}</div>
            {footer && <div className="th-form__layout__footer">{footer}</div>}
        </div>
    );
};
